module.exports = {"pt-BR":{"admin":{"financial":{"transfers":{"filters":{"liquidatedField":{"label":"Liquidado?","true":"Sim","false":"Não"}}}}}}}